import "./App.css";

import MainPage from "./Components/MainPage.js";
import IconizedMenu from "./Components/IconizedMenu.js";

import React, { useEffect, useState } from "react";
import { ApiKey, dataUrl, LoginUrl } from "./config.js";
import { ApplyTheme } from "./Components/DarkModeToggle.js";
import axios from "axios";
import BreakScreen from "./Components/BreakScreen";
import Spinner from "./Components/Spinner.js";
import LogoAndEaseMenu, { EaseMenuDiag } from "./Components/LogoAndEaseMenu.js";
import MainScreen from "./Components/MainScreen.js";
import Subscribe from "./Components/Subscribe.js";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

function App() {
  const [subjects, setSubjects] = useState(null);
  const [revisions, setRevisions] = useState(null);
  const [showBreakScreen, setshowBreakScreen] = useState(false);
  const [showIconizedMenu, setshowIconizedMenu] = useState(true);
  const [refreshTokenCount, setRefreshTokenCount] = useState(0);
  const [showBreakScreenError, setshowBreakScreenError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [forceRefresh, setForceRefresh] = useState(0);
  const [easeMenu, setEaseMenu] = useState(false);
  const [showSubscribe, setShowSubscribe] = useState(false);

  // error notification
  const [errorMsg, setErrorMsg] = useState("");
  const [showError, setShowError] = useState(false);

  const raiseError = (err) => {

     if (typeof err === "string") {
    setErrorMsg(err);
    setShowError(true);
    return;
  }

    const code = err?.response?.data?.code;
    let msg = '';
  if (code === "DUPLICATE_SESSION")
    msg =  "You were logged out because your account was signed in on another device.";
  else if (err?.response?.status === 401)
    msg =  "Session expired. Please log in again.";

  setErrorMsg(msg || "Something went wrong");
  setShowError(true);
};

    const [page, setPage] = useState({
    SubjectPage: {
      loadSubjectPage: false, 
      selectedSub: null
    }, 
    ContentPage : {
     loadContentPage: false, 
     TK: null, 
     Topic:null,
     Type:null},
     SearchResultsPage: 
     {
      loadSearchResultsPage: false,
      SearchResults : null
     },
     PracticeQuizPage:
     {
       loadPraticeQuizPage: false,
       subjectsList: null
     },
     ExamQuizPage:
     {
       loadExamQuizPage : false,
       subjectSelected: null
     }
    }
    );

  function ToggleEaseMenu()
  {
   setEaseMenu(!easeMenu);
  }
  useEffect(() => {
    const preventSaveShortcut = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "s") {
        e.preventDefault();
      }
    };
    window.addEventListener("keydown", preventSaveShortcut);


    if (localStorage.getItem("user") === null) {
        setIsLoading(false);
        setSubjects(null);
        setRevisions(null);
    } else {
      var isSunMode =
        localStorage.getItem("islightmode") != null
          ? JSON.parse(localStorage.getItem("islightmode"))
          : true;
      ApplyTheme(isSunMode);
      sessionStorage.clear();
      var reqsubjects = {
        email: localStorage.getItem("user"),
        method: "GetMenu",
      };
      const headers = { 
        "x-api-key": ApiKey,
      };
      axios
        .post(dataUrl, reqsubjects, { withCredentials: true, headers: headers })
        .then((resp) => {
        //console.log(resp.data.Menu);
              setSubjects(resp.data.Menu);
              setRevisions(resp.data.Revisions);
              setIsLoading(false);
        })
        .catch((err) => {
          FailedReq(err);
        });
  }

  return () => {
      window.removeEventListener("keydown", preventSaveShortcut);
  };
  }, []);

  function updateRevisions(revisions) {
    setRevisions(revisions);
  }

  useEffect(() => {
    // When subjects loaded for the first time.
    // in 50 min break.
    const breakepoch = localStorage.getItem("breaktime");
    
    if (!breakepoch) return;

   const breaktime = 52*60*1000;//50
    var millsec  = breaktime - (new Date().getTime() - breakepoch);

    if (millsec <= 0) {
        FailedReq();
        return;
      }
    const timer = setTimeout(() => {
      if (localStorage.getItem("user")) setshowBreakScreen(true);
    }, millsec);
    return () => clearTimeout(timer);
  },  [refreshTokenCount]);

  // we are storing the email in local storage so no need to login every time.
  function FailedReq(err) {
    // Todo:: server call to delete the token.
    // Dirty fix clean childs and then parents.
    localStorage.clear();
    sessionStorage.clear();
    setShowSubscribe(false);
    setTimeout(function(){
    setSubjects(null);
    setRevisions(null);
    setIsLoading(false);
    setshowBreakScreen(false);
    raiseError(err);
    },1000);
  }


  function RefreshSession(password) {
    var req = {
      email: localStorage.getItem("user"),
      password: password,
    };
    const headers = { 
      "x-api-key": ApiKey,
    };
    axios
      .post(LoginUrl, req, { withCredentials: true, headers: headers })
      .then((resp) => {
        localStorage.setItem("breaktime", new Date().getTime());
        setshowBreakScreen(false);
        setRefreshTokenCount(refreshTokenCount+1);
      })
      .catch((err) => {
        setIsLoading(false);
        setshowBreakScreenError(
          "Failed refreshing session, incorrect password entered!"
        );
        setTimeout(() => {
          setshowBreakScreenError(null);
        }, 3000);
    });  
  }

  function selectSubject(sub) {
    setShowSubscribe(false);
    if (!sub.DirectContent) {
        setPage({ 
        SubjectPage: {
                      loadSubjectPage: true, 
          selectedSub: sub,
                    },
        ContentPage: {
                      loadContentPage: false, 
                      TK: null, 
                      Topic:null,
                      Type: null,
                    },
        SearchResultsPage: {
                      loadSearchResultsPage: false,
          SearchResults: null,
                    },
                    PracticeQuizPage:
                    {
                      loadPraticeQuizPage: false,
                      subjectsList: null
                    },
                    ExamQuizPage:
                    {
                      loadExamQuizPage : false,
                      subjectSelected: null
                    }
                });
    } else {
      onLoadContentPage(
        sub.SubjectName,
        sub.SubjectName,
        sub.SubjectName.toLowerCase(),
        "doc"
      );
    }    
    setForceRefresh(forceRefresh+1);
    setshowIconizedMenu(false);
  }

  function onLoadContentPage(subject, TK, Topic, type) {
    setShowSubscribe(false);
    setPage({ 
      SubjectPage: {
          loadSubjectPage: false, 
        selectedSub: subject,
        },
      ContentPage: {
          loadContentPage: true, 
          TK: TK, 
          Topic:Topic,
          Type: type,
        TopicListForNxtAndPrev: null,
        },
      SearchResultsPage: {
         loadSearchResultsPage: false,
        SearchResults: null,
        },
        PracticeQuizPage:
        {
          loadPraticeQuizPage: false,
          subjectsList: null
        },
        ExamQuizPage:
        {
          loadExamQuizPage : false,
          subjectSelected: null
        }
      });
  }

  function loginSuccess(email) {
    localStorage.setItem("user", email);
    var reqsubjects = {
      email: localStorage.getItem("user"),
      method: "GetMenu",
    };
    const headers = { 
      "x-api-key": ApiKey,
    };
    axios
      .post(dataUrl, reqsubjects, { withCredentials: true, headers: headers })
      .then((resp) => {
        localStorage.setItem("breaktime", new Date().getTime());
            setSubjects(resp.data.Menu);
            setRevisions(resp.data.Revisions);
            setRefreshTokenCount(refreshTokenCount+1);
      })
      .catch((err) => {
        FailedReq(err);
      });
  }
  // Todo show iconized menu toggleable instead do nothing.
  function ToggleIconizedMenu() {
    setShowSubscribe(false);
    // initial state
    if (!page.SubjectPage.loadSubjectPage &&
      !page.ContentPage.loadContentPage &&
      !page.SearchResultsPage.loadSearchResultsPage
    )
      return;
    setshowIconizedMenu(!showIconizedMenu);
  }
 
  function SearchResults(results, searchstring) {
    setEaseMenu(false);
    setshowIconizedMenu(false);
    setShowSubscribe(false);
    setPage({
      SubjectPage: {
        loadSubjectPage: false, 
        selectedSub: null,
      }, 
      ContentPage : {
       loadContentPage: false, 
       TK: null, 
       Topic:null,
        Type: null,
      },
      SearchResultsPage: {
        loadSearchResultsPage: true,
        SearchResults : results,
        SearchStringUsed: searchstring
       }
      ,
        PracticeQuizPage:
        {
          loadPraticeQuizPage: false,
          subjectsList: null
        },
        ExamQuizPage:
        {
          loadExamQuizPage : false,
          subjectSelected: null
        }
    });
  }


  function onLoadContentPageFromEaseMenu(subject, TK, Topic, type) {
    setEaseMenu(false);
    setshowIconizedMenu(false);
    setShowSubscribe(false);
    setPage({ 
      SubjectPage: {
          loadSubjectPage: false, 
        selectedSub: subject,
        },
      ContentPage: {
          loadContentPage: true, 
          TK: TK, 
          Topic:Topic,
          Type: type,
        TopicListForNxtAndPrev: null,
        },
      SearchResultsPage: {
         loadSearchResultsPage: false,
        SearchResults: null,
        },
        PracticeQuizPage:
        {
          loadPraticeQuizPage: false,
          subjectsList: null
        },
        ExamQuizPage:
        {
          loadExamQuizPage : false,
          subjectSelected: null
        }
      });
  }
  function showSubscriptionPage()
  {
    setShowSubscribe(true);
  }

  //{loggedInUser ? <MainPage/> : <Login loggedInUser={loggedInUser} OnSuccess={loginSuccess}/>
  return (
    <div className="App">
      {isLoading ? (
        <Spinner wholepage={true} />
      ) : (
        <div>
          {showBreakScreen && (
            <BreakScreen
              backToLogin={FailedReq}
              OnContinue={RefreshSession}
              breakError={showBreakScreenError}
            />
          )}
          {subjects && easeMenu && (
            <EaseMenuDiag
              subjects={subjects}
              OnSearchResults={SearchResults}
              backToLogin={FailedReq}
              loadContentPage={onLoadContentPageFromEaseMenu}
              revisions={revisions}
              onRevisionsUpdate={updateRevisions}
            />
          )}
        <div className="grid h-screen 
            grid-cols-1 grid-rows-[auto_1fr] 
            md:grid-cols-[auto_80px] md:grid-rows-1">
            {subjects && (
              <LogoAndEaseMenu
                OnClickFunction={ToggleIconizedMenu}
                onClickEaseMenu={ToggleEaseMenu}
                isIconizedMenu={showIconizedMenu}
                notificationCount={
                  (revisions ?? []).filter(r => {
                    const today = new Date().setHours(0, 0, 0, 0);
                    const d = new Date(r.NextRevisionDate).setHours(0, 0, 0, 0);
                    return d <= today;
                  }).length
                }
              />
            )}
            <div
              className="OtherThanSideBar"
              onClick={() => setEaseMenu(false)}
              onTouchStart={() => setEaseMenu(false)}
            >
              {!showSubscribe  ? <div>
              {subjects && showIconizedMenu && (
                <div className={showIconizedMenu ? "menu-enter  top-[35px] pb-[80px] w-full left-0 md:top-0 md:w-[calc(100vw-80px)] md:left-[80px] flex flex-col" : ""}>
                <IconizedMenu
                  subjects={subjects}
                  passselectedsub={selectSubject}
                  OnBannerClick= {showSubscriptionPage}
                />
                </div>
              )}
              {subjects ? (
                <MainPage
                  key={forceRefresh}
                  backToLogin={FailedReq}
                  subjects={subjects}
                  initialpage={page}
                  revisions={revisions}
                  onRevisionsUpdate={updateRevisions}
                />
              ) : (
                <MainScreen OnSuccess={loginSuccess} />
              )}</div> : <Subscribe msg={"Unlock Your Path to Success"} backToLogin={FailedReq}/>}
        </div>
        </div>
        </div>
      )}
      <Snackbar
      open={showError}
      autoHideDuration={4000}
      onClose={() => setShowError(false)}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        severity="error"
        variant="filled"
        onClose={() => setShowError(false)}
      >
        {errorMsg || "Something went wrong"}
      </Alert>
    </Snackbar>
      </div>
  );
}

export default App;